'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackingPixelCodes = require('./TrackingPixelCodes');

var _TrackingPixelCodes2 = _interopRequireDefault(_TrackingPixelCodes);

var _TrackingPixel = require('./TrackingPixel');

var _TrackingPixel2 = _interopRequireDefault(_TrackingPixel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fbEventTypes = {
  FORM_SUBMITTED: 'ViewContent',
  PORTAL_CREATED: 'CompleteRegistration',
  ACTIVATED: 'InitiateCheckout',
  WAU: 'Lead'
};

var TrackingPixelUtils = {
  trackSignupFlow: function trackSignupFlow() {
    _TrackingPixel2.default.twitterAds(_TrackingPixelCodes2.default.TWITTER_ADS_SIGNUP_FORM);
    _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.FORM_SUBMITTED);
    _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.FORM_SUBMITTED);
    return _TrackingPixel2.default.bing(_TrackingPixelCodes2.default.BING_ADS);
  },
  trackCreatedPortal: function trackCreatedPortal() {
    _TrackingPixel2.default.googleAdwords();
    _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.PORTAL_CREATED);
    _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.PORTAL_CREATED);
    _TrackingPixel2.default.quora(_TrackingPixelCodes2.default.QUORA_USER_CREATE);
    return _TrackingPixel2.default.clickMeter(_TrackingPixelCodes2.default.CLICKMETER_CRM_SIGNUP);
  },
  trackUserActivation: function trackUserActivation() {
    _TrackingPixel2.default.googleAdwords(_TrackingPixelCodes2.default.GOOGLE_ADSWORDS_ACTIVATION);
    _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.ACTIVATED);
    return _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.ACTIVATED);
  },
  trackPortalActivation: function trackPortalActivation() {},

  // not in use
  trackActiveUser: function trackActiveUser() {
    _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_SMARTPIXEL_ID, fbEventTypes.WAU);
    return _TrackingPixel2.default.facebookCategory(_TrackingPixelCodes2.default.FACEBOOK_PAGEVIEW_LATAM, fbEventTypes.WAU);
  }
};

exports.default = TrackingPixelUtils;
module.exports = exports['default'];